import React from "react";
import { useLocation } from "react-router-dom";

const PAGE_META: Record<string, { title: string; description: string; icon: string }> = {
  "/users": {
    title: "Users",
    description: "Browse and manage all registered users.",
    icon: "👥",
  },
};

const PlaceholderPage: React.FC = () => {
  const { pathname } = useLocation();
  const meta = PAGE_META[pathname] ?? {
    title: pathname.replace(/\//g, " ").replace(/[-]/g, " ").trim(),
    description: "This section is under construction.",
    icon: "🚧",
  };

  return (
    <div className="min-h-[calc(100dvh-64px)] bg-gradient-to-b from-slate-50 to-white flex flex-col">
      <div className="h-28 bg-gradient-to-r from-[#195f9a] to-[#2d8dd4] flex items-end px-8 pb-5">
        <div>
          <p className="text-blue-200 text-xs font-medium uppercase tracking-widest mb-1">
            Module
          </p>
          <h1 className="text-white text-2xl font-bold flex items-center gap-2">
            <span>{meta.icon}</span> {meta.title}
          </h1>
        </div>
      </div>

      <div className="flex-1 p-6 md:p-10 max-w-5xl w-full mx-auto">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
          <p className="text-gray-500 text-sm">{meta.description}</p>
          <p className="text-center text-gray-400 text-xs mt-8">
            This page is coming soon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderPage;
